import { useEffect, useState } from "react";

import { getFormatDate } from "~/libs/getFormatDate";
import { IGroup, ILevel, TableName } from "./types";

import {
  useGetCompositionPositionProgramsQuery,
  useGetGroupCurriculumByIdQuery,
  useGetLevelCurriculumByIdQuery,
  useGetLevelsQuery,
} from "~/schemas/generated/graphql";
import { get } from "lodash";

export const transformTableData = (
  dataItems: (ILevel | IGroup)[],
  table: TableName
) => {
  if (!dataItems || !Array.isArray(dataItems)) {
    return [];
  }

  if (table === TableName.level) {
    return dataItems.map((item: ILevel) => {
      return {
        ...item,
        status: transformStatus(item.status),
        dateActiveStatus: getFormatDate(item.dateActiveStatus),
        dateInactiveStatus: getFormatDate(item.dateInactiveStatus),
        createdAt: getFormatDate(item.createdAt),
        updatedAt: getFormatDate(item.updatedAt),
        groupName: item.Group.name,
      };
    });
  } else if (table === TableName.group) {
    return dataItems?.map((item: IGroup) => {
      return {
        ...item,
        status: transformStatus(item.status),
        dateActiveStatus: getFormatDate(item.dateActiveStatus),
        dateInactiveStatus: getFormatDate(item.dateInactiveStatus),
      };
    });
  }
  return [];
};

export const transformStatus = (status: string) => {
  switch (status) {
    case "active":
      return "Активный";
    case "inactive":
      return "Неактивный";
    default:
      return "";
  }
};

const useGetCurriculumById = (useQuery, getterPath: string, currentId) => {
  const [entity, setEntity] = useState();

  // Хук вызывается всегда, запрос пропускается через skip — иначе при
  // закрытии модалки (currentId становится пустым) ломается порядок хуков
  const getData = useQuery({
    variables: { id: currentId },
    skip: !currentId,
  });

  useEffect(() => {
    const entityData = get(getData, getterPath, []);
    setEntity(entityData);
  }, [getData]);

  return { entity, refetch: getData.refetch };
};

export const useGetLevel = (currentId = null) => {
  const { entity, refetch } = useGetCurriculumById(
    useGetLevelCurriculumByIdQuery,
    "data.EducationGetter.getLevelCurriculumById",
    currentId
  );

  return { level: entity as ILevel, refetch };
};

export const useGetGroup = (currentId = null) => {
  const { entity, refetch } = useGetCurriculumById(
    useGetGroupCurriculumByIdQuery,
    "data.EducationGetter.getGroupCurriculumById",
    currentId
  );

  return { group: entity as IGroup, refetch };
};

export const useGetAllLevels = () => {
  const [levels, setLevels] = useState([]);

  const getData = useGetLevelsQuery({
    variables: {
      page: 0,
      count: 100,
    },
  });

  const loading = getData.loading;

  useEffect(() => {
    const levelsData = get(
      getData,
      "data.EducationGetter.getListLevelCurriculum.items",
      []
    );
    setLevels(levelsData);
  }, [getData]);

  return { levels, loading };
};

export const useGetTrainingProgramById = (id: string = null) => {
  const [trainingProgram, setTrainingProgram] = useState();

  const getData =
    id &&
    useGetCompositionPositionProgramsQuery({
      variables: { PositionGroupId: id },
      fetchPolicy: "no-cache",
    });

  const refetch = id && getData.refetch;
  const loading = id && getData.loading;

  useEffect(() => {
    const positionData = get(
      getData,
      "data.EducationGetter.getCompositionPositionPrograms"
    );
    setTrainingProgram(positionData);
  }, [getData]);

  return { trainingProgram, refetch, loading };
};
